export default {
  getGrupoOpcionTpl: state => {
    let table = 'GrupoOpcion'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
